<mat-card>
  <mat-card-title>
    <div class="header-wrapper">
      <div class="title-text">
        <span>Buy/Sell</span>
        <span class='contract'> - </span>
      </div>
      <div class="icons">
        <!-- <mat-icon svgIcon="resize"></mat-icon>
        <mat-icon svgIcon="close"></mat-icon> -->
        <!-- <div class="on-chain">
          <mat-slide-toggle
            color='primary'
            labelPosition="before"
          >On-Chain</mat-slide-toggle>
        </div> -->
      </div>
    </div>
  </mat-card-title>
  <mat-card-content>
    <div class="order-type">
      <div class="order-type-buttons">
        <p
          [ngClass]="{ selected: isLimitSelected }"
          (click)="isLimitSelected = true"
        >Limit</p>
        <p
          [ngClass]="{ selected: !isLimitSelected }"
          (click)="isLimitSelected = false"
        >Market</p>
      </div>
    </div>
    <div class="buy-sell-form" [formGroup]='buySellGroup'>
      <div class="custom-form-field" *ngIf='isLimitSelected'>
        <div class="prefix">Price</div>
        <input type='number' formControlName="price">
        <div class="suffix">{{ selectedMarket.second_token.shortName }}</div>
      </div>
      <div class="custom-form-field">
        <div class="prefix">Amount</div>
        <input type='number' formControlName="amount">
        <div class="suffix">{{ selectedMarket.first_token.shortName }}</div>
      </div>
    </div>
    <div class="buy-sell-info">
      <div class="column">
        <span>Fee: {{ getFees(true).toFixed(6) }} LTC </span>
      </div>
      <div class="column">
        <span>Fee: {{ getFees(false).toFixed(6) }} LTC </span>
      </div>
    </div>
    <div class="buttons">
     <button mat-raised-button color="primary" (click)="handleBuySellBuy()" [disabled]="getButtonDisabled()">
  Long
</button>
<button mat-raised-button color="warn" (click)="handleBuySellSell()" [disabled]="getButtonDisabled()">
  Short
</button>
    </div>
    <div class="buy-sell-info max" *ngIf="futureAddress">
      <div class="column" (click)="fillMax(true)">
        <span>Max: {{ getMaxAmount(true).toFixed(6) }} {{ this.selectedMarket.collateral.shortName }} </span>
      </div>
      <div class="column" (click)="fillMax(false)">
        <span>Max: {{ getMaxAmount(false).toFixed(6) }} {{ this.selectedMarket.collateral.shortName }} </span>
      </div>
    </div>
    <div class="address">
      <button
        *ngIf="!futureAddress"
        class="blueButton"
        (click)='newFutureAddress()'
      >Create Futures Address</button>
      <div class="address-info" *ngIf="futureAddress">
        <div class="key-value-pair">
          <div class="key">Address:</div>
          <div class="value">{{ futureAddress | shortAddress }}</div>
        </div>
        <div class="key-value-pair">
          <div class="key">{{ getNameBalanceInfo(selectedMarket.collateral)[0] }}:</div>
          <div class="value">{{ getNameBalanceInfo(selectedMarket.collateral)[1] }}</div>
        </div>
        <div class="key-value-pair">
          <div class="key">Attestation:</div>
          <div class="value">{{ isFutureAddressSelfAtt() }}</div>
        </div>
        <div class="key-value-pair"></div>
      </div>
    </div>
    <div class="additional-info" *ngIf="futureAddress">
      <button
        class="blueButton"
        (click)='closeAll()'
      >Close All Orders</button>
    </div>
    <div class="liquidity">
      <div class="custom-form-field">
        <div class="prefix">Amount</div>
        <input type='number' #liquidity_amount>
        <div class="suffix">{{ selectedMarket.first_token.shortName }} / {{ selectedMarket.second_token.shortName }}</div>
      </div>
      <div class="custom-form-field">
        <div class="prefix">Number Buy/Sell Orders</div>
        <input type='number' #liquidity_orders>
        <div class="suffix"> </div>
      </div>
      <div class="custom-form-field">
        <div class="prefix">Max. Price Range</div>
        <input type='number' #liquidity_range>
        <div class="suffix">%</div>
      </div>
      <!--<button
        class="blueButton"
        (click)='addLiquidity(liquidity_amount.value, liquidity_orders.value, liquidity_range.value)'
      >Add Liquidity</button>
      <button
        class="redButton"
        (click)='stopLiquidity()'
      >Stop Liquidity</button>-->
    </div>
  </mat-card-content>
</mat-card>

<div class="overlay-loading" *ngIf='isLoading'>
  <mat-spinner></mat-spinner>
</div>